// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateInitialLoad = isInitialLoad => ({
    isInitialLoad,
    type: actions.UPDATE_TCSM_AUDIT_IS_INITIAL_LOAD
});



// WEBPACK FOOTER //
// ./src/tcsm/audits/action-creators/is-initial-load.js